import React, { Component } from 'react'
import { connect } from 'react-redux'
import {
    PERMISSION_VACANCIES_WRITE
  } from '../../constants'
import StatusBadge from '../common/helpers/StatusBadge'
import ActivateOrEditVoiceTestPopup from './helpers/ActivateOrEditVoiceTestPopup'
import ConfirmRequestPopup from '../common/helpers/ConfirmRequestPopup'
import { clearVoiceTest } from '../../actions/pages/voice-test-page'
import PieChartPanel from '../common/statistics/PieChartPanel'
import AreaChartPanel from '../common/statistics/AreaChartPanel'
import ProtectedElement from '../common/helpers/ProtectedElement'

class VoiceTestOverview extends Component {
  render() {
    if (this.props.overview === null) {
      return (<div />)
    }
    let overviewData = this.props.overview;

    let status = (<StatusBadge status={overviewData.Status.toLowerCase()} statusLabel={overviewData.Status} />)

    let manageBtn = (
      <ProtectedElement permission={PERMISSION_VACANCIES_WRITE}>
        <div className="row">
          <div className="col text-right">
            <ActivateOrEditVoiceTestPopup voiceTestId={this.props.voiceTestId} profileType={overviewData.ProfileType}/>
            {this.props.overview.Status === 'Active' &&
              <ConfirmRequestPopup
                url={'vacancies/' + this.props.voiceTestId + '/close'}
                btnLabel="Close"
                confirmationQuestion="Are you sure you want to close this voice test and make it not visible to the talents?"
                successMessage="The voice test was closed."
                onSuccess={() => { this.props.clearVoiceTest() }} />
            }
            {this.props.overview.Status === 'Closed' && this.props.overview.ProductionStatus === 'Active' &&
              <ConfirmRequestPopup
                url={'vacancies/' + this.props.overview.Id + '/reopen'}
                btnLabel="Reopen"
                successMessage="The voice test was re-opened."
                onSuccess={() => { this.props.clearVoiceTest() }} />
            }
          </div>
        </div>
      </ProtectedElement>
    )

    return (
      <div>
        {manageBtn}
        <div className="row">
          <div className="col-md-6 widget">
            <div className="title">Overview</div>
            <div className="row">
              <div className="col">
                <div className="row">
                  <div className="col-4">Production title:</div>
                  <div className="col-8"><a href={'/productions/' + overviewData.ProductionId + '/overview'}>{overviewData.ProductionTitle}</a></div>
                </div>
                <div className="row">
                  <div className="col-4">Description:</div>
                  <div className="col-8">{overviewData.Description} (Voice Test)</div>
                </div>
                <div className="row">
                  <div className="col-4">Status:</div>
                  <div className="col-8">{status}</div>
                </div>
                <div className="row">
                  <div className="col-4">Deadline:</div>
                  <div className="col-8">{overviewData.DeadlineAsString} {overviewData.DeadlineDaysLeft ? '(' + overviewData.DeadlineDaysLeft + ')' : 'Not specified'}</div>
                </div>
                <div className="row">
                  <div className="col-4">Facility:</div>
                  <div className="col-8">{overviewData.Facility}</div>
                </div>
                <div className="row">
                  <div className="col-4">Notes:</div>
                  <div className="col-8">{overviewData.AdditionalNotes}</div>
                </div>
                <div className="row">
                  <div className="col-4">Schedule:</div>
                  <div className="col-8">
                    {overviewData.Periods.map((period, i) => (
                      <div key={i}>{period}</div>
                    ))}
                  </div>
                </div>
                <div className="row">
                  <div className="col-4">Actual work:</div>
                  <div className="col-8">{overviewData.ActualWorkAmount}</div>
                </div>
                <div className="row">
                  <div className="col-4">Offered work:</div>
                  <div className="col-8">{overviewData.WorkAmount ? overviewData.WorkAmount : 'Not set yet'}</div>
                </div>
              </div>
            </div>
          </div>
          <div className="col-md-6 widget">
            <div>
              <PieChartPanel title="Candidates" data={overviewData.StatisticsOfCandidates} colors={["blue", "darkblue", "green", "indigo", "purple"]} />
            </div>
            <div>
              <AreaChartPanel title="Views" data={overviewData.StatisticsOfViews} />
            </div>
          </div>
        </div>
        {manageBtn}
      </div>
    )
  }
}

const mapStateToProps = (state, ownProps) => ({
  overview: state.voiceTestPage.overview
})
const mapDispatchToProps = dispatch => ({
  clearVoiceTest() { dispatch(clearVoiceTest()) }
})
export default connect(mapStateToProps, mapDispatchToProps)(VoiceTestOverview)
